import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import applicationReducer from "state/application/applicationSlice";
import authReducer from "state/auth/authSlice";
import communityReducer from "state/communities/communitiesSlice";
import simulatorReducer from "state/simulator/simulatorSlice";
import taskReducer from "state/tasks/tasksSlice";
import apiSlice from "./api/apiSlice";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  blacklist: [apiSlice.reducerPath],
};

const reducers = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  auth: authReducer,
  community: communityReducer,
  application: applicationReducer,
  simulator: simulatorReducer,
  tasks: taskReducer,
});

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(apiSlice.middleware),

  // switch to false for production
  devTools: true,
});

setupListeners(store.dispatch);

export default store;
